import React, { MutableRefObject, useContext } from 'react'
import { styled } from '../../../lib/stitches'
import { Image, Row } from '../../core/Components'
import { LoopContext } from './InstrumentLoop'

const Container = styled(Row, {
  overflowY: 'hidden',
  overflowX: 'hidden',
  cursor: 'pointer',
  width: '100%',
  height: '100%',
  color: 'var(--studio-very-light)',
  variants: {
    isEven: {
      true: {
        color: 'var(--studio-light)'
      }
    }
  }
})

interface EmptyInstrumentLoopProps {
  isEven: boolean
}

const EmptyInstrumentLoop = React.forwardRef(
  ({ isEven }: EmptyInstrumentLoopProps, ref: MutableRefObject<HTMLImageElement>) => {
    const loopData = useContext(LoopContext)
    const [showLargePlus, setShowLargePlus] = React.useState(false)

    const showPlusSign = showLargePlus || loopData.showLoopDropdown || loopData.isHoveringDropdown
    return (
      <Container
        onClick={() => loopData.setShowLoopDropdown(!loopData.showLoopDropdown)}
        onMouseEnter={() => setShowLargePlus(true)}
        onMouseLeave={() => {
          setShowLargePlus(false)
          loopData.setShowLoopDropdown(false)
        }}
        isEven={isEven}
        horizontalCenter
        verticalCenter
        unselectable
      >
        {showPlusSign && (
          <Image ref={ref} src="/static/icons/add_muted_24dp.svg" css={{ height: '50%' }} />
        )}
      </Container>
    )
  }
)

export default EmptyInstrumentLoop
